import React, { Fragment } from 'react';
import { v4 as uuid } from 'uuid';
import { STATISTICAL_METHODS } from '../../../../../../RJS/schemas/dataSchemas/enum/enum';
import './StatisticalAnalysisItem.scss';

const StatisticalAnalysisItem = ({
  index,
  data,
  schema,
  view,
  bgColor,
  outcomeMeasure
}) => {
  let analysisSchema = schema.properties[view].properties.outcome_measure.properties.outcome_measure_analysis.properties;

  const getDisplayValue = (value) => {
    if (value === undefined || value === null || value === "") return "-"
    return value
  }

  const displayValue = (fieldKey, fieldSchema) => {
    if (fieldSchema.type === "multiselect") {
      let items = fieldSchema.enum ? fieldSchema.enum : [];
      if (fieldKey === "outcome_reporting_groups") {
        items = getReportingGroupItems()
      }

      let selectedItems = []


      if (data[fieldKey]) {
        data[fieldKey].forEach(item => {
          let foundItem = items.find(option => option.id === item.arm_id);
          if (foundItem) {
            selectedItems.push(foundItem.text)
          }
        })
      }

      return <p key={uuid()} style={{ margin: 0 }}>{selectedItems.join(`, \n`)}</p>
    }

    let value = data[fieldKey]

    if (fieldKey === "ci_num_sides" || fieldKey === "ci_pct_value" || fieldKey === "ci_upper_limit" || fieldKey === "ci_lower_limit") {
      if ((fieldKey === "ci_num_sides" || fieldKey === "ci_pct_value") && data["ci_num_sides"] && data["ci_pct_value"]) {
        if (fieldKey === "ci_num_sides") return;
        value = `(${getDisplayValue(data["ci_num_sides"])}) ${getDisplayValue(data[fieldKey])}%`
      } else if (fieldKey === "ci_upper_limit" || fieldKey === "ci_lower_limit") {
        if ((data["ci_upper_limit"] === undefined || data["ci_upper_limit"] === "" || data["ci_upper_limit"] === null) && (data["ci_lower_limit"] === undefined || data["ci_lower_limit"] === "" || data["ci_upper_limit"] === null)) {
          return;
        }
        if (data["ci_num_sides"] === "1-Sided") {
          if (data["ci_lower_limit"]) {
            if (fieldKey === "ci_lower_limit") {
              value = `${getDisplayValue(data["ci_lower_limit"])}}`
            } else {
              return
            }
          } else if (data["ci_upper_limit"]) {
            if (fieldKey === "ci_upper_limit") {
              value = `${getDisplayValue(data["ci_upper_limit"])}`
            } else {
              return
            }
          }
        } else {
          if (fieldKey === "ci_lower_limit") {
            value = `${getDisplayValue(data[fieldKey])} to ${getDisplayValue(data["ci_upper_limit"])}`
          } else if (fieldKey === "ci_upper_limit") {
            return;
          }
        }
      }
    } else if (fieldKey === "dispersion_type") {
      if (data[fieldKey]) {
        value = `Type: ${data[fieldKey]}`
      }
    } else if (fieldKey === "dispersion_value") {
      if (data[fieldKey]) {
        value = `Value: ${data[fieldKey]}`
      }
    } else if(fieldKey === "statistical_method") {
      let foundItem = STATISTICAL_METHODS.find(item => item?.value === value)
      if(foundItem?.registries?.[view]) value = foundItem.registries[view]
    }

    return (
      <p key={uuid()}>{value}</p>
    )
  }

  const getReportingGroupItems = () => {
    let items = []
    if (outcomeMeasure.arms) {
      let arms = outcomeMeasure.arms.map(item => ({ id: item.id, text: `${item.title}` }))
      items = [...arms]
    }

    if (outcomeMeasure.subject_analysis_sets) {
      let subject_analysis_sets = outcomeMeasure.subject_analysis_sets.map(item => ({ id: item.id, text: `${item.title}` }))
      items = [...items, ...subject_analysis_sets]
    }
    return items
  }

  const displaySubjectsInAnalysis = () => {
    let total = 0;

    data?.outcome_reporting_groups?.forEach(group => {
      outcomeMeasure?.arms?.forEach(arm => {
        if (arm.id === group.arm_id) {
          if (arm.subjects_analyzed) {
            total += Number(arm?.subjects_analyzed) || 0
          }
        }
      })

      outcomeMeasure?.subject_analysis_sets?.forEach(arm => {
        if (arm.id === group.arm_id) {
          if (arm.subjects_analyzed) {
            total += Number(arm?.subjects_analyzed) || 0
          }
        }
      })
    })

    return (
      <tr>
        <td style={{
          backgroundColor: bgColor,
          width: 250
        }}>
          Subjects in this analysis
        </td>
        <td>
          <div className="sas-preview-field-container">
            {total}
          </div>
        </td>
      </tr>
    )
  }

  return (
    <>
      <p className="sas-preview-title">
        {index + 1}. Statistical Analysis Set
      </p>
      <div className="statistical-analysis-item-preview-container">
        <table>
          <tbody>
            {Object.keys(analysisSchema).map((sectionKey, i) => {
              return (
                <Fragment key={uuid()}>
                  <tr key={sectionKey + index + i}>
                    <td style={{
                      backgroundColor: bgColor,
                      fontWeight: "bold",
                      width: 250
                    }}
                      colSpan={2}>
                      {analysisSchema[sectionKey].title}
                    </td>
                  </tr>
                  {Object.keys(analysisSchema?.[sectionKey]?.properties)?.map((rowKey, j) => (
                    <Fragment key={rowKey + index + j}>
                      <tr>
                        <td style={{
                          backgroundColor: bgColor,
                          width: 250
                        }}>
                          {analysisSchema?.[sectionKey]?.properties?.[rowKey]?.title}
                        </td>
                        <td>
                          <div className="sas-preview-field-container">
                            {Object.keys(analysisSchema[sectionKey]?.properties?.[rowKey]?.properties).map(fieldKey => {
                              let fieldSchema = analysisSchema[sectionKey].properties[rowKey].properties[fieldKey]
                              return displayValue(fieldKey, fieldSchema)
                            })}
                          </div>
                        </td>
                      </tr>
                      {view === "eudract" && rowKey === "outcome_reporting_groups_container" && displaySubjectsInAnalysis()}
                    </Fragment>
                  ))}
                </Fragment>
              )
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default StatisticalAnalysisItem;